import './Button.css';

function Button (props) {
    return (
        <div>
            <button className='button' onClick={props.onClickFunction}>{props.buttonText}</button>
        </div>
    )
}

export default Button;